import { useContext } from 'react';

import { EmbedDataContext } from './embed_data_context';
import { TRANSPOREON_PRODUCT_NAME } from '../../constants';

export const useProductName = (): string => {
  const { embedConfig } = useContext(EmbedDataContext);
  return embedConfig?.product_name ?? TRANSPOREON_PRODUCT_NAME;
};
